import React,  { Component } from 'react'

// redux 
import { connect } from 'react-redux'
import ReportActions from '../../../redux/report/actions'

// ui
import Button from '../../../components/uielements/button'

class SelectTier extends Component {
    _handleUpdateSelectButton = (selectStr) => {
        this.props.userChangeSelectTier(selectStr)
    }

    render(){
        const { tier_select } = this.props
        const classAll = tier_select=== 0 ? "FilterButtonSelect" : "FilterButton"
        const classTier1 = tier_select=== 1 ? "FilterButtonSelect" : "FilterButton"
        const classTier2 = tier_select === 2 ? "FilterButtonSelect" : "FilterButton"
        const classTier3 = tier_select === 3 ? "FilterButtonSelect" : "FilterButton"

        return (
            <div className="FilterHeader">
                <Button icon="unordered-list" className={classAll} onClick={() => this._handleUpdateSelectButton(0)}>
                    Tất cả
                </Button>
                <Button icon="file-protect" className={classTier1} onClick={() => this._handleUpdateSelectButton(1)}>
                    Tier 1
                </Button>
                <Button icon="snippets" className={classTier2} onClick={() => this._handleUpdateSelectButton(2)}>
                    Tier 2
                </Button>
                <Button icon="snippets" className={classTier3} onClick={() => this._handleUpdateSelectButton(3)}>
                    Tier 3
                </Button>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        tier_select: state.qbreport.tier_select
    }
}

const mapDispatchToProps = dispatch => {
    return {
        userChangeSelectTier: tier_id => {
            dispatch(ReportActions.action.userChangeSelectTier(tier_id))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectTier)